export const formatDate = (date: string): string => {
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

function downloadURI(link: string, name: string): void {
  const a = document.createElement("a");
  a.style.display = "none";
  a.href = link;
  a.download = name;
  a.target = "_blank";
  document.body.appendChild(a);
  a.click();
  a.remove();
}

export const downloadBinaryFile = (
  binaryFile: BlobPart,
  fileName: string,
): void => {
  const blob = new Blob([binaryFile], { type: "application/octet-stream" });
  const url = URL.createObjectURL(blob);
  downloadURI(url, fileName);
  URL.revokeObjectURL(url);
};
